import PureHttp from "@/services/PureHttp";

export default {
    async login(username, password, params = {}) {
        return PureHttp.post(`/api/authenticate`, {username, password}, {params: params});
    }
}
